var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#C7CAD1;}\n"),React.createElement("path",{"className":"st0","d":"M11.8,10l7.1-7.1c0.2-0.2,0.4-0.6,0.4-0.9s-0.1-0.7-0.4-0.9c-0.5-0.5-1.3-0.5-1.8,0L10,8.2L2.9,1.1\n\tc-0.5-0.5-1.3-0.5-1.8,0C0.9,1.3,0.7,1.7,0.7,2c0,0.3,0.1,0.7,0.4,0.9L8.2,10l-7.1,7.1c-0.2,0.2-0.4,0.6-0.4,0.9\n\tc0,0.3,0.1,0.7,0.4,0.9c0.5,0.5,1.3,0.5,1.8,0l7.1-7.1l7.1,7.1c0.2,0.2,0.6,0.4,0.9,0.4c0.3,0,0.7-0.1,0.9-0.4\n\tc0.5-0.5,0.5-1.3,0-1.8L11.8,10z","key":1})]);
}

CloseIcon.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 20 20","style":{"enableBackground":"new 0 0 20 20"},"xmlSpace":"preserve"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
